<template>
    <div class="relative w-screen h-screen bg-slate-900 overflow-hidden flex flex-col items-center justify-center">
        <div class="flex flex-col justify-center items-center">
            <div class="relative z-50 flex items-end text-[5rem] sm:text-[10rem] lg:text-[15rem] theme-text leading-none my-10">
                <font-awesome-icon icon="fa-solid fa-wifi" class="animate-pulse"/>
            </div>
            <p class="relative z-50 text-xl sm:text-3xl text-slate-200 text-center">اتصال شما به اینترنت برقرار نمی‌باشد</p>
        </div>

        <!-- bottom shape -->
        <div class="absolute -bottom-12 -right-80 w-full flex items-center gap-8">
            <div v-for="(item, index) in 25" :key="index"
                class="relative min-w-[100px] aspect-square border-4 theme-border rotate-45 opacity-90 rounded-xl blur-[2px]">
                <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-80">
                    <div class="relative w-5/6 aspect-square border-4 theme-border rounded-lg"></div>
                    <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-70">
                        <div class="relative w-4/6 aspect-square border-4 theme-border rounded-lg"></div>
                        <div class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-60">
                            <div class="relative w-3/6 aspect-square border-4 theme-border rounded-md"></div>
                            <div
                                class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-50">
                                <div class="relative w-2/6 aspect-square border-4 theme-border rounded-md"></div>
                                <div
                                    class="absolute -left-full w-full aspect-square flex items-start justify-end opacity-40">
                                    <div class="relative w-1/6 aspect-square border-4 theme-border"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

//data
const isMounted = ref(false);


onMounted(() => {
    isMounted.value = true;
})

</script>